export default __webpack_public_path__ + "img/partnership8-2575ac3b419244ab1e698173da0bd60f.png";